import React, { memo as Memo, useState, useEffect, useMemo, useRef } from 'react'
import { useRouter } from 'next/router'


//* HOC's
import { withUIContext, withDataContext } from 'context'

//* Components
import { Text, Title, AnimationWrapp, Image, Button, Page } from 'components/common'
import { SingleWork } from 'components/pages'

//* Helpers
import { arrayGenChild } from 'helpers'
import { gsap } from 'gsap'

//* Style
import ExhibitionsStyle from 'styles/pages/ExhibitionsStyle'

const Exhibitions = Memo(({ pages, pageParams, selectedLang, winWidth }) => {
    const titleRef = useRef()
    const workImgRef = useRef()
    const photoImgRef = useRef()

    //! States
    const [secObj, setSecObj] = useState()
    const [paginations, setPaginations] = useState([1, 1])
    const [activeImgWork, setActiveImgWork] = useState(undefined)
    const [activeImgPhoto, setActiveImgPhoto] = useState(undefined)

    //! Page Data
    const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, selectedLang, pageParams.name])

    const router = useRouter()

    useEffect(() => {
        if (pageData && titleRef?.current) {
            setSecObj([arrayGenChild(titleRef.current[0])])
        }
    }, [pageData, titleRef, selectedLang])

    useEffect(() => {
        gsap.fromTo(workImgRef.current, { scale: 0 }, { scale: 1, duration: 0.5 })
    }, [activeImgWork])

    useEffect(() => {
        gsap.fromTo(photoImgRef.current, { scale: 0 }, { scale: 1, duration: 0.5 })
    }, [activeImgPhoto])

    const storeWorks = useMemo(() => {
        if (pageData?.exhibitions.work) {
            let arr = pageData?.exhibitions.work

            return arr.map((i, k) => {
                if (k < paginations[0] * 10) {
                    return (
                        <SingleWork
                            key={k}
                            onMouseEnter={() => setActiveImgWork(i.image)}
                            year={i.year}
                            city={i.city}
                            title={i.title}
                            gallery={i.gallery}
                        />
                    )
                }
            })
        }
    }, [pageData?.exhibitions.work, paginations[0], activeImgWork])

    const storePhotos = useMemo(() => {
        if (pageData?.exhibitions.photo) {
            let arr = pageData?.exhibitions.photo

            return arr.map((i, k) => {
                if (k < paginations[1] * 10) {
                    return (
                        <SingleWork
                            key={k}
                            onMouseEnter={() => setActiveImgPhoto(i.image)}
                            year={i.year}
                            city={i.city}
                            title={i.title}
                            gallery={i.gallery}
                        />
                    )
                }
            })
        }
    }, [pageData?.exhibitions.photo, paginations[1], activeImgPhoto])

    const loadMore = (index) => {
        let arr = [...paginations]
        arr[index]++
        setPaginations([...arr])
    }

    const isLocaleArmenia = router.locale === 'hy' ? true : false

    return (
        <Page className='overflowHidden' meta={pageData?.content.meta}>
            {pageData ? (
                <AnimationWrapp state={secObj}>
                    <ExhibitionsStyle isArm={isLocaleArmenia}>
                        <div className='top-section FlexBoxColumn'>
                            <Title
                                className={'justifyEnd '}
                                ref={titleRef}
                                title={{
                                    1: [{ type: 'big', name: 'Museum' }, { type: 'icon' }],
                                    2: [{ type: 'min', name: 'Exhibitions' }],
                                }}
                            />
                            <Text tag={'p'} className={'pM NotoSansRegular text-1'} text={pageData.content.section_1_text_1} />
                            <div className='texts FlexBoxColumn'>
                                <Text tag={'p'} className={'pM NotoSansRegular text-2'} text={pageData.content.section_1_text_2} />
                                <Text tag={'h6'} className={'h6 GHEAMariamRegular text-3'} text={pageData.content.section_1_text_3} />
                            </div>
                            <Image className='picture1' src='/images/Exhibitions/picture1.png' />
                            <Image className='picture2' src='/images/Exhibitions/picture2.png' />
                            <Image className='picture3' src='/images/Exhibitions/picture3.png' />
                            <Image className='butterfly1' src='/images/Exhibitions/butterfly1.png' />
                            <Image className='butterfly2' src='/images/Exhibitions/butterfly2.png' />
                            <Image className='angel' src='/images/Exhibitions/angel.png' />
                            <Image className='coin' src='/images/Exhibitions/coin.png' />
                            <Image className='elephant' src='/images/Exhibitions/elephant.png' />
                        </div>
                        <div className='exhibition FlexBoxColumn work'>
                            <div className='title'>
                                <Text tag={'h4'} className={'h4 NotoSansRegular'} text={pageData.content.section_2_title} />
                            </div>
                            <div className='table FlexBoxColumn'>
                                {winWidth > 1279 && activeImgWork !== undefined && (
                                    <Image ref={workImgRef} src={activeImgWork} alt='featured_image' />
                                )}
                                <div className='table-heading FlexBox'>
                                    <Text tag={'p'} className={'year pL uppercase GHEAMariamBold'} text={'year'} />
                                    <Text tag={'p'} className={'city pL uppercase GHEAMariamBold'} text={'city'} />
                                    <Text tag={'p'} className={'ex pL uppercase GHEAMariamBold'} text={'exhibition'} />
                                    <Text tag={'p'} className={'gallery pL uppercase GHEAMariamBold'} text={'galleryMuseum'} />
                                </div>
                                <div className='works FlexBoxColumn'>{storeWorks}</div>
                            </div>
                            {paginations[0] * 10 < pageData?.exhibitions.work.length && (
                                <Button text={'LoadMore'} className={'reverseColor'} btnAnimation={true} onClick={() => loadMore(0)} />
                            )}
                        </div>
                        <div className='exhibition FlexBoxColumn '>
                            <div className='title'>
                                <Text tag={'h4'} className={'h4 NotoSansRegular'} text={pageData.content.section_3_title} />
                            </div>
                            <div className='table FlexBoxColumn'>
                                {winWidth > 1279 && activeImgPhoto !== undefined && (
                                    <Image ref={photoImgRef} src={activeImgPhoto} alt='featured_image' />
                                )}
                                <div className='table-heading FlexBox'>
                                    <Text tag={'p'} className={'year pL uppercase GHEAMariamBold'} text={'year'} />
                                    <Text tag={'p'} className={'city pL uppercase GHEAMariamBold'} text={'city'} />
                                    <Text tag={'p'} className={'ex pL uppercase GHEAMariamBold'} text={'exhibition'} />
                                    <Text tag={'p'} className={'gallery pL uppercase GHEAMariamBold'} text={'galleryMuseum'} />
                                </div>
                                <div className='works FlexBoxColumn'>{storePhotos}</div>
                            </div>
                            {paginations[1] * 10 < pageData?.exhibitions.photo.length && (
                                <Button text={'LoadMore'} btnAnimation={true} onClick={() => loadMore(1)} />
                            )}
                        </div>
                    </ExhibitionsStyle>
                </AnimationWrapp>
            ) : null}
        </Page>
    )
})

export default withUIContext(withDataContext(Exhibitions, ['pages']), ['winWidth'])
